import React, { useState, useEffect } from "react";
import { apiFetch } from "./api";

export default function Settings({ client, onBack, onLogout }) {
  const [clientEmail, setClientEmail] = useState("");
  const [clientEmailCc, setClientEmailCc] = useState("");
  const [frequency, setFrequency] = useState("monthly");
  const [daily, setDaily] = useState(false); // dummy for now (not saved)
  const [monthly, setMonthly] = useState(false); // dummy for now (not saved)

  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState(""); // "", "ok", "error"
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (client) {
      setClientEmail(client.email || "");
      setClientEmailCc(client.email_cc || "");
      setFrequency(client.report_frequency || "monthly");
      setDaily(!!client.send_daily);
      setMonthly(!!client.send_monthly);
    }
  }, [client]);

  const handleSave = async () => {
    if (!client?.id) return;
    setSaving(true);
    setStatus("");
    setMessage("");
    try {
      const res = await apiFetch(`/api/clients/${client.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          company_email: clientEmail,
          company_email_cc: clientEmailCc,
          report_frequency: frequency,
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.detail || `Salvestamine ebaõnnestus (HTTP ${res.status})`);
      setStatus("ok");
      setMessage("Salvestatud.");
    } catch (err) {
      console.error("Save failed", err);
      setStatus("error");
      setMessage(err.message || "Salvestamine ebaõnnestus.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#F3F6FD",
        fontFamily: "'DM Sans', sans-serif",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          width: "100%",
          backgroundColor: "#0D1F4D",
          padding: "16px 24px",
          color: "white",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: "20px",
          fontWeight: 700,
          boxSizing: "border-box",
        }}
      >
        <span>Klientidele automaatne raportite saatmine</span>

        <button
          onClick={onLogout}
          style={{
            backgroundColor: "#8CA5E6",
            color: "white",
            border: "none",
            padding: "8px 14px",
            borderRadius: "6px",
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          Logi välja
        </button>
      </div>

      {/* SETTINGS CARD */}
      <div
        style={{
          width: "500px",
          margin: "60px auto",
          backgroundColor: "white",
          borderRadius: "14px",
          padding: "30px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        <h2
          style={{
            fontWeight: 700,
            color: "#0D1F4D",
            marginBottom: "20px",
            textAlign: "center",
            fontSize: "22px",
          }}
        >
          Muuda klienti
        </h2>

        {/* NAME (read-only) */}
        <label
          style={{
            fontWeight: 600,
            color: "#0D1F4D",
            display: "block",
            marginBottom: "6px",
          }}
        >
          Kliendi nimi
        </label>
        <input
          type="text"
          value={client?.name || ""}
          readOnly
          title="Nime ei saa siin muuta"
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "18px",
            borderRadius: "8px",
            border: "1px solid #E6ECF8",
            background: "#F3F6FD",
            color: "#555",
            fontSize: "14px",
            fontFamily: "'DM Sans', sans-serif",
            cursor: "not-allowed",
          }}
        />

        {/* EMAIL(S) */}
        <label
          style={{
            fontWeight: 600,
            color: "#0D1F4D",
            display: "block",
            marginBottom: "6px",
          }}
        >
          E-mail(id)
        </label>
        <input
          type="text"
          placeholder="klient@example.com, teine@example.com"
          value={clientEmail}
          onChange={(e) => setClientEmail(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "6px",
            borderRadius: "8px",
            border: "1px solid #8CA5E6",
            fontSize: "14px",
            fontFamily: "'DM Sans', sans-serif",
          }}
        />
        <div style={{ fontSize: "12px", color: "#666", marginBottom: "18px" }}>
          Mitu aadressi eralda komaga.
        </div>

        {/* CC EMAIL(S) */}
        <label
          style={{
            fontWeight: 600,
            color: "#0D1F4D",
            display: "block",
            marginBottom: "6px",
          }}
        >
          Koopia (CC)
        </label>
        <input
          type="text"
          placeholder="koopia@example.com, teine@example.com"
          value={clientEmailCc}
          onChange={(e) => setClientEmailCc(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "6px",
            borderRadius: "8px",
            border: "1px solid #8CA5E6",
            fontSize: "14px",
            fontFamily: "'DM Sans', sans-serif",
          }}
        />
        <div style={{ fontSize: "12px", color: "#666", marginBottom: "18px" }}>
          Mitu aadressi eralda komaga. Jäta tühjaks, kui koopiat pole vaja.
        </div>

        {/* REPORTING FREQUENCY — drives the "raport tegemata" warning colour */}
        <label
          style={{
            fontWeight: 600,
            color: "#0D1F4D",
            display: "block",
            marginBottom: "6px",
          }}
        >
          Aruandluse sagedus
        </label>
        <select
          value={frequency}
          onChange={(e) => setFrequency(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "6px",
            borderRadius: "8px",
            border: "1px solid #8CA5E6",
            fontSize: "14px",
            fontFamily: "'DM Sans', sans-serif",
            background: "#fff",
          }}
        >
          <option value="monthly">Kuine</option>
          <option value="semimonthly">Poolkuine</option>
        </select>
        <div style={{ fontSize: "12px", color: "#666", marginBottom: "22px" }}>
          Määrab, kui kaua tohib viimasest raportist mööduda, enne kui põhivaates
          kuupäev kollaseks värvub (kuine 25 päeva, poolkuine 12).
        </div>

        {/* CHECKBOXES (dummies for now) */}
        <div style={{ marginBottom: "6px" }}>
          <label style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
            <input
              type="checkbox"
              checked={daily}
              onChange={(e) => setDaily(e.target.checked)}
              style={{ transform: "scale(1.2)", marginRight: "10px" }}
            />
            <span style={{ fontSize: "15px", color: "#0D1F4D", fontWeight: 600 }}>
              Saada päevased
            </span>
          </label>

          <label style={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              checked={monthly}
              onChange={(e) => setMonthly(e.target.checked)}
              style={{ transform: "scale(1.2)", marginRight: "10px" }}
            />
            <span style={{ fontSize: "15px", color: "#0D1F4D", fontWeight: 600 }}>
              Saada kuised
            </span>
          </label>
        </div>
        <div style={{ fontSize: "12px", color: "#999", marginBottom: "20px" }}>
          (Automaatne saatmine pole veel kasutusel — neid veel ei salvestata.)
        </div>

        {status === "ok" && (
          <div
            style={{
              background: "#E7F6EC",
              border: "1px solid #B6E2C6",
              color: "#1E8449",
              borderRadius: "8px",
              padding: "10px 12px",
              fontSize: "13px",
              marginBottom: "16px",
              fontWeight: 600,
            }}
          >
            {message}
          </div>
        )}
        {status === "error" && (
          <div
            style={{
              background: "#FDECEA",
              border: "1px solid #F5C6C0",
              color: "#C0392B",
              borderRadius: "8px",
              padding: "10px 12px",
              fontSize: "13px",
              marginBottom: "16px",
              fontWeight: 600,
            }}
          >
            {message}
          </div>
        )}

        {/* BUTTONS */}
        <button
          onClick={handleSave}
          disabled={saving}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: saving ? "#9AA8C7" : "#0D1F4D",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontWeight: 700,
            fontSize: "15px",
            cursor: saving ? "not-allowed" : "pointer",
            marginBottom: "12px",
            fontFamily: "'DM Sans', sans-serif",
            transition: "0.2s",
          }}
        >
          {saving ? "Salvestan…" : "Salvesta"}
        </button>

        <button
          onClick={onBack}
          style={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#8CA5E6",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "15px",
            cursor: "pointer",
            fontFamily: "'DM Sans', sans-serif",
            transition: "0.2s",
          }}
        >
          Tagasi klientide nimekirja
        </button>
      </div>
    </div>
  );
}
